import { Metamodel } from '../base/model';
import { IModel, IViolation } from '../base/annotation';
import { LinkedService } from './linkedservice';
import { validateAKVLinkedserviceReference, validateNullLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { AzureKeyVault } from './key-vault';
import { AzureStorageLinkedService } from './azure-storage.linkedservice';
import { ParameterConfig } from '../pipeline/parameter-config';
import { format } from 'app/shared/utils/string.util';
import { IValidationContext, azureStorageAuthTypes, Credential } from 'shell-models-lib';
import { AzureBlobFSLinkedService } from './azure-blob-fs.linkedservice';
import { GlobalVariables } from 'app/services/globals';

@Metamodel.model({
    name: 'HDInsightOnDemand',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.HdiOnDemand_FullName),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.HdiOnDemand_FullName)
    ]
})
export class HDInsightOnDemandLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
    @Metamodel.attribute({
        display: stringResources.ModelName_HdiOnDemand_ClusterSize
    })
    public clusterSize?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_HdiOnDemand_TimeToLive
    })
    public timeToLive?: string;

    @Metamodel.attribute({
        display: stringResources.VersionLabel
    })
    public version?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_HdiOnDemand_HostSubsId
    })
    public hostSubscriptionId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_HdiOnDemand_ClusterRp
    })
    public clusterResourceGroup?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_HdiOnDemand_ClusterType
    })
    public clusterType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID
    })
    public servicePrincipalId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        reference: true,
        display: stringResources.AzureStorage_LinkedServiceLabel,
        type: AzureStorageLinkedService.MODEL,
        constraint: {
            validator: GlobalVariables.enableAllConnectionParamForExternalActivities && __IS_FABRIC_DPE__ ? undefined : HDInsightOnDemandLinkedService.validation
        }
    })
    public storageLinkedService?: AzureStorageLinkedService | AzureBlobFSLinkedService;

    @Metamodel.attribute({
        reference: true,
        display: stringResources.ModelName_HdiOnDemand_AdditionalLinkedServices,
        type: AzureStorageLinkedService.MODEL
    })
    public additionalLinkedServices?: AzureStorageLinkedService[];

    @Metamodel.attribute({
        reference: true,
        display: stringResources.ModelName_HdiOnDemand_HCatalogLinkedService,
        type: AzureStorageLinkedService.MODEL
    })
    public hcatalogLinkedService?: AzureStorageLinkedService;

    @Metamodel.attribute({
        display: stringResources.ModelName_SubnetName
    })
    public subnetName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_VirtualNetworkId
    })
    public virtualNetworkId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant
    })
    public tenant: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_SparkVersion
    })
    public sparkVersion?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_clusterNamePrefix
    })
    public clusterNamePrefix?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_OsType
    })
    public osType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_clusterUserName
    })
    public clusterUserName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_clusterPassword,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public clusterPassword?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_clusterSshUserName
    })
    public clusterSshUserName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_clusterSshPassword,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public clusterSshPassword?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_ScriptName
    })
    public scriptName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ScriptUri
    })
    public scriptUri?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ScriptNodeTypes
    })
    public scriptNodeTypes?: string[] = [];

    @Metamodel.attribute({
        display: stringResources.ModelName_ScriptParameters
    })
    public scriptParameters?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_HeadNodeSize
    })
    public headNodeSize?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_DataNodeSize
    })
    public dataNodeSize?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ZookeeperNodeSize
    })
    public zookeeperNodeSize?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_CoreConfig
    })
    public coreConfiguration?: ParameterConfig[];

    @Metamodel.attribute({
        display: stringResources.ModelName_HBaseConfig
    })
    public hbaseConfiguration?: ParameterConfig[];

    @Metamodel.attribute({
        display: stringResources.ModelName_HDFSConfig
    })
    public hdfsConfiguration?: ParameterConfig[];

    @Metamodel.attribute({
        display: stringResources.ModelName_HiveConfig
    })
    public hiveConfiguration?: ParameterConfig[];

    @Metamodel.attribute({
        display: stringResources.ModelName_MapReduceConfig
    })
    public mapReduceConfiguration?: ParameterConfig[];

    @Metamodel.attribute({
        display: stringResources.ModelName_OozieConfig
    })
    public oozieConfiguration?: ParameterConfig[];

    @Metamodel.attribute({
        display: stringResources.ModelName_StormConfig
    })
    public stormConfiguration?: ParameterConfig[];

    @Metamodel.attribute({
        display: stringResources.ModelName_YarnConfig
    })
    public yarnConfiguration?: ParameterConfig[];

    @Metamodel.attribute({
        display: stringResources.ModelName_HdiOnDemand_ClusterResourcGroupAuthType,
    })
    public clusterResourceGroupAuthType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_HdiOnDemand_ClusterResourceGroupUAMICredential,
        reference: true
    })
    public credential?: Credential;

    public isNotExistingversion: boolean = true;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public static async validation(linkedservice: LinkedService, referencedResource: LinkedService, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> {
        const validators = await validateNullLinkedserviceReference(linkedservice, referencedResource, violation, context) || [];

        if (GlobalVariables.enableHDIStorageLSAuthValidate) {
            // No support for MSI and UAMI auth for Ondemand cluster storage linked service
            if (linkedservice instanceof HDInsightOnDemandLinkedService && linkedservice.storageLinkedService) {
                HDInsightOnDemandLinkedService._checkAuthTypeForStorageLinkedServiceAndAddValidationError(linkedservice, validators);
            }
        }
        
        return validators;
    }

    private static _checkAuthTypeForStorageLinkedServiceAndAddValidationError(linkedservice: HDInsightOnDemandLinkedService, validators: IViolation[]) : void {

        if (linkedservice.storageLinkedService.authenticationMethod === azureStorageAuthTypes.MSIAuthentication || 
            linkedservice.storageLinkedService.authenticationMethod === azureStorageAuthTypes.UserAssignedManagedIdentity) {
            validators.push({
                message: () =>
                    format(
                        stringResources.Error_InvalidHDIAuthStorageService,
                        linkedservice.storageLinkedService.authenticationMethod
                    )
            });
        }
    }
}
